"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_head_1 = __importDefault(require("vue-head"));
var toastr_1 = __importDefault(require("toastr"));
var app_1 = __importDefault(require("./router/app"));
var app_2 = __importDefault(require("./store/app"));
var RootView_vue_1 = __importDefault(require("./components/app/RootView.vue"));
var GtagImage_vue_1 = __importDefault(require("./components/app/GtagImage.vue"));
var app_3 = __importDefault(require("./http/app"));
var vue_scrollto_1 = __importDefault(require("vue-scrollto"));
var vue_gtag_1 = __importDefault(require("vue-gtag"));
vue_1.default.prototype.$toastr = toastr_1.default;
vue_1.default.prototype.$http = app_3.default;
vue_1.default.prototype.$analyticsId = process.env.MIX_GOOGLE_ANALYTICS_ID;
vue_1.default.component('root-view', RootView_vue_1.default);
vue_1.default.component('gtag-image', GtagImage_vue_1.default);
vue_1.default.use(vue_head_1.default, {
    separator: '|',
    complement: '急性期ケア専門士認定登録申し込み'
});
vue_1.default.use(vue_scrollto_1.default);
vue_1.default.use(vue_gtag_1.default, {
    config: {
        id: process.env.MIX_GTM_TAG
    }
});
new vue_1.default({
    el: '#app',
    router: app_1.default,
    store: app_2.default,
    render: function (h) { return h(RootView_vue_1.default); }
});
